// @spec POL-STR-031
'use client';

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { ProcedureExecutionPage } from '@/features/policies/components/ProcedureExecutionPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/policies/procedures/$instanceId/execute')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.executeProcedure'),
  }),
  component: ProcedureExecuteRoute,
});

/**
 * Procedure execution route - Step-by-step execution interface.
 *
 * Displays:
 * - Procedure title and progress
 * - List of steps with status indicators
 * - Step details with notes and evidence
 * - Action buttons for start, complete, cancel
 * - Submit for review when all steps complete
 */
function ProcedureExecuteRoute() {
  const { instanceId } = Route.useParams();
  const navigate = useNavigate();

  const handleBack = () => {
    void navigate({ to: '/policies' });
  };

  const handleComplete = () => {
    void navigate({ to: '/policies' });
  };

  return (
    <div className="container max-w-4xl py-6">
      <ProcedureExecutionPage
        instanceId={instanceId}
        onBack={handleBack}
        onComplete={handleComplete}
      />
    </div>
  );
}
